var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNormallike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.23242 15.292L8.81575 17.292C9.14909 17.6254 9.89909 17.792 10.3991 17.792H13.5658C14.5658 17.792 15.6491 17.042 15.8991 16.042L17.8991 9.95871C18.3158 8.79205 17.5658 7.79205 16.3158 7.79205H12.9824C12.4824 7.79205 12.0658 7.37538 12.1491 6.79205L12.5658 4.12538C12.7324 3.37538 12.2324 2.54205 11.4824 2.29205C10.8158 2.04205 9.98242 2.37538 9.64909 2.87538L6.23242 7.95871",
    stroke: "#8C8C8C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.98242 15.293V7.1263C1.98242 5.95964 2.48242 5.54297 3.64909 5.54297H4.48242C5.64909 5.54297 6.14909 5.95964 6.14909 7.1263V15.293C6.14909 16.4596 5.64909 16.8763 4.48242 16.8763H3.64909C2.48242 16.8763 1.98242 16.4596 1.98242 15.293Z",
    stroke: "#8C8C8C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormallike);
export default __webpack_public_path__ + "static/media/normallike.23c8ddf9b94cbe41f9e4147cc0cc6ef8.svg";
export { ForwardRef as ReactComponent };